import script from "./FiltrosDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./FiltrosDropdown.vue?vue&type=script&setup=true&lang=js"

import "./FiltrosDropdown.vue?vue&type=style&index=0&id=3f4907d8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f4907d8"]])

export default __exports__